import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined'
import EditIcon from '@material-ui/icons/Edit'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import { Card } from 'shared/components/Base/Base'
import { Box } from 'shared/components/Box/Box'
import { Button } from 'shared/components/Button/Button'
import { Text } from 'shared/components/Text/Text'
import { Handler, HandlerOf } from 'shared/helpers/typeHelper'
import { DrivingViolation, DrivingViolationTypeDetail } from 'shared/models/employment'
import { bgGray, darkGray, dividerGray, error, errorD1, midGray } from 'shared/theme/colors'
import styled, { css } from 'styled-components'

interface ViolationsListProps {
  violations: DrivingViolation[]
  onEdit: HandlerOf<DrivingViolation>
  onAdd: Handler
}

export const ViolationWrap = styled.div`
  width: 100%;
`

export const ViolationCard = styled(Card).attrs({
  hasSubtleShadow: true,
})<{ $hasMoreViolations?: boolean }>`
  padding: 20px 20px 18px;
  width: 100%;
  text-align: left;
  position: relative;

  &:first-child {
    ${(p) =>
      p.$hasMoreViolations &&
      css`
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
      `}
  }

  & + & {
    border-top-right-radius: 0;
    border-top-left-radius: 0;
    border-top: 1px solid ${bgGray};
  }
`

export const ViolationEditIcon = styled(EditIcon)`
  font-size: 14px;
  color: ${dividerGray};
  position: absolute;
  top: 20px;
  right: 20px;
`

export const ViolationErrorIcon = styled(ErrorOutlineIcon)`
  font-size: 20px;
  padding: 3px;
  color: ${errorD1};
  background: ${error};
  border-radius: 50%;
  position: absolute;
  top: 20px;
  right: 20px;
`

export function ViolationsList({ violations, onEdit, onAdd }: ViolationsListProps) {
  function renderContent() {
    if (!violations.length) {
      return (
        <ViolationCard onClick={onAdd}>
          <Box mt={2} />
          <Button margin="0 auto" variant="text" icon={<AddCircleOutlineOutlinedIcon />}>
            Add violation
          </Button>
          <Box mt={2} />
        </ViolationCard>
      )
    }

    return (
      <>
        {violations.map((violation) => (
          <ViolationCard
            key={violation.id}
            onClick={() => onEdit(violation)}
            $hasMoreViolations={violations.length > 1}
          >
            {violation.isComplete ? <ViolationEditIcon /> : <ViolationErrorIcon />}
            <Text variant="uppercaseLabel2" fontColor={midGray}>
              {addBullet([
                new Date(violation.date).toLocaleString('en-us', { month: 'short', year: 'numeric' }),
                violation.address,
              ])}
            </Text>
            <Text variant="label3" fontColor={darkGray} mt={1}>
              {addBullet([
                DrivingViolationTypeDetail.get(violation.violationType),
                formatCMV(violation.isInCommercialVehicle),
              ])}
            </Text>
          </ViolationCard>
        ))}
        <Box mt={2} />
        <Button margin="0 auto" variant="text" icon={<AddCircleOutlineOutlinedIcon />} onClick={onAdd}>
          Add violation
        </Button>
      </>
    )
  }

  return <ViolationWrap>{renderContent()}</ViolationWrap>
}

export function addBullet(arr: any[]) {
  return arr.filter((v) => v != null).join(' • ')
}

export function formatCMV(check?: boolean) {
  if (check === true) return 'In CMW'
  if (check === false) return 'Not in CMW'
  return null
}
